import {InjectionToken} from "@angular/core";
export * from './services/http-intercept.service'
export * from './services/loader.service'
export * from './components/toast.component'
export * from './services/localstorage.service'

export const APP_CONFIG = new InjectionToken("Application config");
